var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "flex-col w-1/3 mt-3 pr-4"
  }, [_c('label', {
    staticClass: "text-gray-600 text-sm font-semibold mb-3 block"
  }, [_vm._v("Coupon Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border rounded-lg w-full",
    class: {
      'border-red-500 placeholder-red-500 bg-red-200 text-red-700 text-base': _vm.isCouponNameError,
      'bg-gray-100': _vm.mode === 'edit' && this.status
    },
    attrs: {
      "id": "coupon-Name",
      "placeholder": "e.g.: Bagi-Bagi Buku Gramedia",
      "type": "text",
      "disabled": _vm.mode === 'edit' && this.status,
      "required": ""
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }, _vm.validateNameInput]
    }
  }), _vm.isCouponNameError ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 block"
  }, [_vm._v("Description")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.description,
      expression: "form.description"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border rounded-lg w-full",
    class: {
      'border-red-500': _vm.isCouponDescriptionError,
      'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': _vm.isCouponDescriptionError
    },
    attrs: {
      "id": "coupon-description",
      "placeholder": "Enter a short description...",
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value);
      }, _vm.validateDescriptionInput]
    }
  }), _vm.isCouponDescriptionError ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 block"
  }, [_vm._v("Client/Buyer Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.bayerName,
      expression: "form.bayerName"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border rounded-lg w-full",
    class: {
      'bg-gray-100': _vm.mode === 'edit' && this.status,
      'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': _vm.isCouponBayerNameError
    },
    attrs: {
      "id": "coupon-Bayer",
      "disabled": _vm.mode === 'edit' && this.status,
      "placeholder": "e.g.: Gramedia Digital",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.bayerName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bayerName", $event.target.value);
      }, _vm.validateBayerNameInput]
    }
  }), _vm.isCouponBayerNameError ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('div', {
    staticClass: "relative"
  }, [_c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 block"
  }, [_vm._v("Coupon Price")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.couponPrice,
      expression: "form.couponPrice"
    }],
    staticClass: "bg-gray-50 py-2.5 pl-8 border rounded-lg w-full",
    class: {
      'bg-gray-100': _vm.mode === 'edit' && this.status,
      'placeholder-red-500 border-red-500 bg-red-200 text-red-700 text-base': _vm.isCouponPriceError
    },
    attrs: {
      "id": "coupon-Bayer",
      "placeholder": "",
      "type": "number",
      "min": "0",
      "disabled": _vm.mode === 'edit' && this.status,
      "required": ""
    },
    domProps: {
      "value": _vm.form.couponPrice
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "couponPrice", $event.target.value);
      }, _vm.validateCouponPriceInput]
    }
  }), _vm.isCouponPriceError ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('span', {
    staticClass: "absolute left-2 top-12 mr-2 text-base text-gray-500",
    class: {
      'border-red-500': _vm.isCouponPriceError,
      'placeholder-red-500 bg-red-200 text-red-700 text-base': _vm.isCouponPriceError
    }
  }, [_vm._v("Rp")])]), _c('div', {
    staticClass: "flex w-full justify-between"
  }, [_c('DatetimeCustom', {
    staticClass: "mt-3 w-full mr-1.5",
    attrs: {
      "timeDate": false,
      "label": 'Valid from'
    },
    model: {
      value: _vm.form.valid_from,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_from", $$v);
      },
      expression: "form.valid_from"
    }
  }), _c('DatetimeCustom', {
    staticClass: "mt-3 w-full ml-1.5",
    attrs: {
      "timeDate": false,
      "label": 'Valid To'
    },
    model: {
      value: _vm.form.valid_to,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_to", $$v);
      },
      expression: "form.valid_to"
    }
  })], 1), _c('label', {
    staticClass: "text-gray-600 font-semibold my-3"
  }, [_vm._v("Platform")]), _c('CustomSelected', {
    class: {
      'pointer-events-none': _vm.editId && this.status
    },
    attrs: {
      "isError": _vm.isError,
      "options": _vm.platformFilters,
      "label": "name",
      "track-by": "id",
      "multiple": true,
      "default-text": 'Select Platform'
    },
    on: {
      "input": _vm.handlePlatformSelection
    },
    model: {
      value: _vm.selectedPlatforms,
      callback: function ($$v) {
        _vm.selectedPlatforms = $$v;
      },
      expression: "selectedPlatforms"
    }
  }), _vm.isError ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be selected.")]) : _vm._e(), _c('label', {
    staticClass: "text-gray-600 font-semibold my-3"
  }, [_vm._v("Product/Offer to Be Redeemed")]), _c('CustomSelected', {
    staticClass: "cursor-pointer",
    attrs: {
      "isError": _vm.isOfferError,
      "options": _vm.premiumOffersOptions,
      "label": "name",
      "track-by": "id",
      "multiple": false,
      "default-text": 'Select Premium Offers'
    },
    on: {
      "input": _vm.onFieldChangeOffers,
      "search-change": _vm.onSearchPremiumOffers
    },
    model: {
      value: _vm.offersPremium,
      callback: function ($$v) {
        _vm.offersPremium = $$v;
      },
      expression: "offersPremium"
    }
  }), _vm.isOfferError ? _c('div', {
    staticClass: "text-red-500 text-xs mt-1"
  }, [_vm._v(" Must be selected. ")]) : _vm._e(), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold mb-3 mt-3 block"
  }, [_vm._v("Status")]), _c('div', [_c('button', {
    staticClass: "w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none",
    class: {
      'bg-blue-700': _vm.form.is_active,
      'bg-gray-300': !_vm.form.is_active
    },
    attrs: {
      "clas": "",
      "type": "button"
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('span', {
    staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
    class: {
      'translate-x-6': _vm.form.is_active,
      'translate-x-0': !_vm.form.is_active
    }
  })])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }